import { Pipe, PipeTransform } from '@angular/core';
import { CritereModel } from 'src/app/_shared/services/advanced-rule/advanced-rule.service';
import { arrayNotEmpty } from 'src/app/utils/array.utils';

@Pipe({
    name: 'findCriterionById',
    standalone: false
})
export class FindCriterionByIdPipe implements PipeTransform {

    transform(value: number, criteriaList: CritereModel[]): CritereModel {
        return arrayNotEmpty(criteriaList) ? criteriaList.find(({Id}) => Id === value) : null;
    }

}
